import React from "react";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ButtonCustom from "./ButtonCustom";
import { yellowButton } from "src/shared/styles/buttonStyles";
import { SvgIcon } from "@mui/material";
import EspecialidadIcon from "src/shared/icons/EspecialidadIcon";
import CalendarioIcon from "src/shared/icons/CalendarioIcon";

const SearchHoursSiteOficial = (props) => {
  return (
    <ButtonCustom
      {...props}
      style={{ ...yellowButton, height: "35px"}}
      text="Agendar Hora"
      icon={
        <SvgIcon>
          <CalendarioIcon />
        </SvgIcon>
      }
    ></ButtonCustom>
  );
};

export default SearchHoursSiteOficial;
